import { EventEmitter, TemplateRef, ViewContainerRef, } from '@angular/core';
import { ReportNamingConvention } from '../../enums/naming-convention.enum';
import * as i0 from "@angular/core";
const _c0 = ["template"];
/**
 * Report Security Search Input Directive
 *
 * Common properties and methods for components that handle input of a report security.
 *
 * Input Properties:
 *  rowCount: row number of the input
 *  namingConvention: naming convention for securities in the report
 *  autocompleterTestID: test id for the autocompleter input.
 *  displayIdentifier: security ID or security list name of the selected security/list
 *  reportLabelPreview: preview of the security label in the report based on the selected naming convention
 *  customLabel: if the "custom" naming convention is selected, this is the custom label that was entered for the selected security
 *  errorMessage: error message to display
 *  disableEditBtn: to disable the edit security button
 *  isDisabled: to disable the autocompleter input
 *
 * Output Properties:
 *  customLabelEmitter: emits when the custom label for the security is changed
 */
export class ReportSecuritySearchInputDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this.namingConvention = ReportNamingConvention.TRUNCATED;
        this.displayIdentifier = '';
        this.errorMessage = '';
        this.disableEditBtn = false;
        this.disableAutocompleterInput = false;
        this.selectSecurityHandler = new EventEmitter();
        // Preview + custom label
        this.reportLabelPreview = '';
        this.customLabelEmitter = new EventEmitter();
    }
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
    }
    updateCustomLabelHandler(event) {
        const customLabel = event.target.value;
        this.customLabelEmitter.emit(customLabel);
    }
    selectSecurity(event) {
        this.selectSecurityHandler.emit(event);
    }
    // Auto completer pass through methods
    reset() {
        this.autoCompleteInPlace.reset();
    }
    cancel() {
        this.autoCompleteInPlace.cancel();
    }
}
ReportSecuritySearchInputDirective.ɵfac = function ReportSecuritySearchInputDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportSecuritySearchInputDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
ReportSecuritySearchInputDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ReportSecuritySearchInputDirective, viewQuery: function ReportSecuritySearchInputDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { rowCount: "rowCount", namingConvention: "namingConvention", autocompleterTestID: "autocompleterTestID", displayIdentifier: "displayIdentifier", errorMessage: "errorMessage", disableEditBtn: "disableEditBtn", disableAutocompleterInput: "disableAutocompleterInput", reportLabelPreview: "reportLabelPreview", customLabel: "customLabel", removeSecurityHandler: "removeSecurityHandler" }, outputs: { selectSecurityHandler: "selectSecurityHandler", customLabelEmitter: "customLabelEmitter" } });
